<template>
    <div ref="mapContainer" style="height: 100%; border-radius:12px;"></div>
</template>

<script>
export default {

    name: 'MultiTourMap',

    props: {
        addresses: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            map: null,
            mapContainer: null,
        }
    },

    mounted() {

        if (!window.mapboxgl) {
            console.error('Mapbox non chargé via CDN')
            return
        }

        window.mapboxgl.accessToken = 'pk.eyJ1IjoidmljdG9yYW53IiwiYSI6ImNrajhuam1iOTZ1dnQydnFqbzRldDJrdW8ifQ.VkIKVhh5_Pcp7PxqQ-GCCg'

        this.map = new window.mapboxgl.Map({
            container: this.$refs.mapContainer,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [4.85, 46],
            zoom: 7
        })

        this.map.on('load', () => {
            this.renderRoutes()
        })
    },

    methods: {

        async renderRoutes() {

            const bounds = new window.mapboxgl.LngLatBounds()

            const grouped = this.groupByClient(this.addresses)

            for (const clientId in grouped) {

                const color = this.getColorFromClient(parseInt(clientId))

                const coords = grouped[clientId]
                    .filter(a => a.deleted_at === null)
                    .map(a => {
                        const lng = parseFloat(a.longitude)
                        const lat = parseFloat(a.latitude)
                        bounds.extend([lng, lat])
                        return [lng, lat]
                    })

                if (coords.length < 2) continue

                // =============================
                // Appel Directions API
                // =============================

                const coordString = coords.map(c => c.join(',')).join(';')

                const url =
                    `https://api.mapbox.com/directions/v5/mapbox/driving/${coordString}` +
                    `?geometries=geojson&overview=full&access_token=${window.mapboxgl.accessToken}`

                try {

                    const response = await fetch(url)
                    const data = await response.json()

                    if (!data.routes || !data.routes.length) continue

                    const routeGeometry = data.routes[0].geometry

                    this.map.addSource(`route-${clientId}`, {
                        type: 'geojson',
                        data: {
                            type: 'Feature',
                            geometry: routeGeometry
                        }
                    })

                    this.map.addLayer({
                        id: `route-layer-${clientId}`,
                        type: 'line',
                        source: `route-${clientId}`,
                        paint: {
                            'line-width': 5,
                            'line-color': color
                        }
                    })

                    // =============================
                    // Markers numérotés
                    // =============================

                    coords.forEach((coord, index) => {

                        const el = document.createElement('div')

                        el.style.background = color
                        el.style.width = '30px'
                        el.style.height = '30px'
                        el.style.borderRadius = '50%'
                        el.style.display = 'flex'
                        el.style.alignItems = 'center'
                        el.style.justifyContent = 'center'
                        el.style.color = 'white'
                        el.style.fontWeight = 'bold'
                        el.style.fontSize = '14px'
                        el.style.boxShadow = '0 0 0 3px white'
                        el.innerText = index + 1

                        new window.mapboxgl.Marker(el)
                            .setLngLat(coord)
                            .addTo(this.map)
                    })

                } catch (error) {
                    console.error('Erreur Mapbox Directions', error)
                }
            }

            if (!bounds.isEmpty()) {
                this.map.fitBounds(bounds, { padding: 60 })
            }
        },

        groupByClient(data) {
            return data.reduce((acc, item) => {
                if (!acc[item.tech_id]) acc[item.tech_id] = []
                acc[item.tech_id].push(item)
                return acc
            }, {})
        },

        getColorFromClient(clientId) {

            const palette = [
                '#E53935',
                '#1E88E5',
                '#43A047',
                '#FB8C00',
                '#8E24AA',
                '#00897B',
                '#6D4C41',
                '#3949AB',
                '#FDD835',
                '#D81B60'
            ]

            return palette[clientId % palette.length]
        }
    }
}
</script>